import * as AriaKit from '@ariakit/react'
import * as React from 'react'

import { TooltipSettingsPropType } from './hooks'

interface TooltipButtonProps extends Omit<AriaKit.TooltipAnchorProps, 'store'> {
  state: TooltipSettingsPropType

  /**
   * Hides tooltip on trigger click
   *
   * @default false
   */
  isHideOnClick?: boolean

  /**
   * Whether to ignore default mouse enter/leave tooltip trigger interactions
   * and hide tooltip only after clicking outside of the trigger element
   *
   * @default false
   */
  isHideOnClickOutside?: boolean
}
/**
 * The trigger button component which handles ref & focus return, etc.
 */
export const TooltipTrigger = React.forwardRef(
  (
    { state, isHideOnClick, isHideOnClickOutside, onClick, onMouseEnter, onMouseLeave, ...props }: TooltipButtonProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => (
    <AriaKit.TooltipAnchor
      ref={ref}
      store={state}
      onClick={(e) => {
        if (isHideOnClick) {
          state.hide()
        }
        onClick?.(e)
      }}
      showOnHover={!isHideOnClickOutside}
      onMouseEnter={(e) => {
        if (isHideOnClickOutside) e.preventDefault()
        onMouseEnter?.(e)
      }}
      onMouseLeave={(e) => {
        if (isHideOnClickOutside) e.preventDefault()
        onMouseLeave?.(e)
      }}
      {...props}
    >
      {props.children}
    </AriaKit.TooltipAnchor>
  )
)
